import { render, staticRenderFns } from "./ScreenParaView.vue?vue&type=template&id=3b343f4c&scoped=true&"
import script from "./ScreenParaView.vue?vue&type=script&lang=js&"
export * from "./ScreenParaView.vue?vue&type=script&lang=js&"
import style0 from "./ScreenParaView.vue?vue&type=style&index=0&id=3b343f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b343f4c",
  null
  
)

export default component.exports